import { CircleCheckSolidV6, TriangleExclamationSolidV6 } from "@shared/v2/Icomoon";
import Tooltip from "@shared/v2/Tooltip";
import PropTypes from "prop-types";

const AddressCard = ({
  containerClassName,
  addressType,
  addressStatus,
  addressStatusClassName,
  streetAddress,
  secondaryAddress,
  country,
  cityStateZip,
  standardized,
  updatedDate,
}) => (
  <div className={containerClassName}>
    <div className="tw-flex tw-flex-row tw-py-[8px] tw-justify-between tw-items-center">
      <div className="tw-flex tw-gap-6px">
        <span className="tw-text-[12px] tw-leading-[24px] tw-font-semibold tw-text-gray-75 tw-capitalize tw-rounded-[6px] tw-border-solid tw-border-1px tw-border-gray-15 tw-px-8px tw-flex tw-items-center">
          {addressType}
        </span>
        {addressStatus ? (
          <span className={`tw-rounded-lg tw-px-8px tw-py-4px tw-text-12px tw-font-semibold ${addressStatusClassName}`}>
            {addressStatus}
          </span>
        ) : null}
      </div>
    </div>
    <div className="tw-flex tw-flex-col tw-text-14px tw-text-nowrap tw-mb-4px">
      <span>{streetAddress}{secondaryAddress ? `, ${secondaryAddress}` : null}</span>
      <div className="tw-flex tw-gap-4px tw-items-center">
        <span>{cityStateZip}{country ? `, ${country}` : ''}</span>
        {{
          standardized: <Tooltip
            placement="right"
            innerClassName="tw-max-w-[258px] !tw-text-left"
            trigger={<CircleCheckSolidV6 className="tw-text-brand-info" />}
            content="This address has been verified and is in a standard format."
          />,
          partialStandardized: null,
          undefined: null,
          null: null,
          invalid: <Tooltip
            placement="right"
            innerClassName="tw-max-w-[258px] !tw-text-left"
            trigger={<TriangleExclamationSolidV6 className="tw-text-[#E5941B]" />}
            content="We aren’t able to verify this address. Please edit and check for accuracy."
          />
        }[standardized]}
      </div>
    </div>

    {updatedDate ? (
      <span className="tw-text-gray-50 tw-text-12d">
        System notified of status change{" "}
        {new Date(updatedDate).toLocaleDateString("en-US", { timeZone: "UTC" })}
      </span>
    ) : null}
  </div>
);

AddressCard.propTypes = {
  containerClassName: PropTypes.string,
  addressType: PropTypes.string,
  addressStatus: PropTypes.string,
  addressStatusClassName: PropTypes.string,
  streetAddress: PropTypes.string,
  secondaryAddress: PropTypes.string,
  cityStateZip: PropTypes.string,
  country: PropTypes.string,
  standardized: PropTypes.bool,
  updatedDate: PropTypes.string,
};

AddressCard.defaultProps = {
  containerClassName: "",
  addressType: "",
  addressStatus: "",
  addressStatusClassName: "",
  streetAddress: "",
  secondaryAddress: "",
  cityStateZip: "",
  country: null,
  standardized: false,
  updatedDate: "",
};

export default AddressCard;